const moduleLoadingMask = {
	namespaced: true,
	state: {
		MASK_ACTIVE: false,
	},
	mutations: {
		SET_MASK_ACTIVE: (state, params) => {
			state.MASK_ACTIVE = params
		},
	},
	actions: {},
	getters: {},
}

export default moduleLoadingMask
